import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";
import "../../styles/ConverterConfig.css";
import "../../styles/ConverterManager.css";
import "../../styles/ContainerCommon.css";

//import ConverterConfig from "../../containers/ConverterConfigContainer";

import { ConvertTypes } from "../../Utilities/converterparamscnf.js";
import { ConvertTypesOut } from "../../Utilities/converterparamscnf.js";

import { Select, MenuItem, TextField, FormControl, FormLabel, IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import { MuiLectraButton, MuiMessageBox } from "@lectra/mui-library";
import { AddIcon } from "@lectra/mui-library-icons";

export default class ConverterManagerPool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedConverterId: "",
      SelectedConverterType: "",
      convertersToShow: [],
      converterTitleToShow: "",
      converterTypeInOutLabel: "",
      ConverterIdInProcessOfRenaming: "",
      askingDeleteConverter: false,
      ErrorNoExit: false,
    };
  }
  componentWillMount() {
    this.ReadConverters(false);
  }

  handleAdd = (event) => {
    const { addConverter, converters } = this.props;
    let newid = "converter1";

    for (let ndx = 1; ndx < 100; ndx++) {
      newid = "converter" + ndx;
      if (converters.findIndex((converter) => converter.id === newid) < 0) break;
    }

    const typeInOut = this.props.typeInOut;

    let mytypeOrigin, mytypeDestination, mytypeInOut;
    if (typeInOut === "In") {
      mytypeOrigin = "accumark";
      mytypeDestination = "mdl";
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    } else if (typeInOut === "Out") {
      mytypeOrigin = "mdl";
      mytypeDestination = "mdl_V7";
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    }
    this.ReadConverters(true);
  };

  handleMoveUp = (converterid, convertertypeInOut) => {
    this.setState({ SelectedConverterId: converterid });
    const { updateConverterOrder, converters } = this.props;
    let posConverterToMoveOrigin = -1,
      posConverterToMoveFinal;
    let i = 0;
    let bFound = 0;
    while (i < converters.length && !bFound) {
      if (converters[i].id === converterid) {
        posConverterToMoveOrigin = i;
        bFound = 1;
      }
      i++;
    }

    i = posConverterToMoveOrigin - 1;
    bFound = 0;
    while (i >= 0 && !bFound) {
      if (converters[i].typeInOut === convertertypeInOut) {
        posConverterToMoveFinal = i;
        bFound = 1;
      }
      i--;
    }
    var converter = converters.splice(posConverterToMoveOrigin, 1)[0];
    converters.splice(posConverterToMoveFinal, 0, converter);
    updateConverterOrder(converters);
    this.ReadConverters(true);
  };

  handlMoveDown = (converterid, convertertypeInOut) => {
    this.setState({ SelectedConverterId: converterid });
    const { updateConverterOrder, converters } = this.props;
    let posConverterToMoveOrigin = -1,
      posConverterToMoveFinal;
    let i = 0;
    let bFound = 0;
    while (i < converters.length && !bFound) {
      if (converters[i].id === converterid) {
        posConverterToMoveOrigin = i;
        bFound = 1;
      }
      i++;
    }

    i = posConverterToMoveOrigin + 1;
    bFound = 0;
    while (i < converters.length && !bFound) {
      if (converters[i].typeInOut === convertertypeInOut) {
        posConverterToMoveFinal = i;
        bFound = 1;
      }
      i++;
    }
    var converter = converters.splice(posConverterToMoveOrigin, 1)[0];
    converters.splice(posConverterToMoveFinal, 0, converter);
    updateConverterOrder(converters);
    this.ReadConverters(true);
  };

  handleChangeType = (converterid, convertertypeInOut, converterNewType) => {
    const { updateConverterType } = this.props;
    if (convertertypeInOut === undefined) convertertypeInOut = "In";
    updateConverterType({
      id: converterid,
      type: converterNewType,
      typeInOut: convertertypeInOut,
    });
    // We change also the selected  converter type on ConverterManagerPool
    this.ReadConverters(true);
  };
  handleCopy = (converterid, convertertypeInOut) => {
    const { copyConverter, converters } = this.props;
    //const { currentDragging } = this.state;
    let currentDragging = converterid;

    const index = converters.findIndex((converter) => converter.id === currentDragging);
    if (index >= 0) {
      const type = converters[index].type;
      const typeDestination = converters[index].typeDestination;
      const typeInOut = converters[index].typeInOut;
      copyConverter({ id: currentDragging, type, typeDestination, typeInOut });
    }
    this.ReadConverters(true);
  };

  handleRemove = (converterid) => {
    const { removeConverter } = this.props;

    if (window.confirm(currentLocals(this.props.locale).converter.sure_to_delete + "\n" + converterid.toUpperCase()))
      removeConverter({ id: converterid });
    this.ReadConverters(true);
  };
  AskDeleteConverter() {
    //Shows the MessageBox
    this.setState({ askingDeleteConverter: true });
    /*
    if (window.confirm(currentLocals(this.props.locale).converter.sure_to_delete + currentDragging.toUpperCase())) {
      removeConverter({ id: currentDragging });
    }*/
  }

  OnOkDelete(converteridtodelete) {
    const { removeConverter } = this.props;
    removeConverter({ id: converteridtodelete });
    this.setState({ askingDeleteConverter: false });
    this.ReadConverters(true);
  }
  OnCancelDelete() {
    this.setState({ askingDeleteConverter: false });
  }
  handleEdit = (converterid, convertertype, convertertypeInOut) => {
    this.setState({ SelectedConverterId: converterid, SelectedConverterType: convertertype });

    const { setConverterOnEdition, setConverterConfigOpen } = this.props;
    setConverterOnEdition(converterid);
    setConverterConfigOpen(true);
    /*
    if (convertertypeInOut === "In") {
      this.state.ConvertersConfigInOpen = true;
      this.state.ConvertersConfigOutOpen = false;
    } else if (convertertypeInOut === "Out") {
      this.state.ConvertersConfigInOpen = false;
      this.state.ConvertersConfigOutOpen = true;
    }*/

    const { getConverterConfig } = this.props;

    getConverterConfig({
      id: converterid,
      type: convertertype,
    });
  };

  handleRename = (newconverterid, index, event) => {
    let newConvertersToShow = this.state.convertersToShow;
    let bError = false;
    let bExist = false,
      bEmptyName = false;
    let sErrorInfo = "";

    newConvertersToShow[index].id = newconverterid;
    if (newconverterid === "") {
      bError = true;
      bEmptyName = true;
    }
    if (!bError) {
      let converters = this.props.converters;
      let i = 0;

      while (i < converters.length && !bExist) {
        if (converters[i].id === newconverterid && this.state.SelectedConverterId !== newconverterid) {
          bError = true;
          bExist = true;
        }
        i++;
      }
    }
    if (bError) {
      if (bExist)
        sErrorInfo =
          String.fromCharCode(parseInt(10811, 10)) +
          "  " +
          currentLocals(this.props.locale).converter.ConverterNameExist;
      if (bEmptyName)
        sErrorInfo =
          String.fromCharCode(parseInt(10811, 10)) +
          "  " +
          currentLocals(this.props.locale).converter.ConverterNameIsEmpty;
      newConvertersToShow[index].error = true;
      newConvertersToShow[index].helperText = sErrorInfo;
    } else {
      newConvertersToShow[index].error = false;
      newConvertersToShow[index].helperText = "";
    }

    this.setState({
      convertersToShow: newConvertersToShow,
      ConverterIdInProcessOfRenaming: newconverterid,
      ErrorNoExit: bError,
    });
    // if (bError == false) event.preventDefault();
    return bError;
  };
  handleOnBlur = (converterid, newconverterid, event) => {
    let converters = this.props.converters;
    const updateConverterId = this.props.updateConverterId;
    let bReturn = true;
    let sInfoValidation;
    let bExiste = false;
    if (this.state.ConverterIdInProcessOfRenaming === "") {
      bReturn = false;
    } else {
      if (newconverterid === "") {
        sInfoValidation = currentLocals(this.props.locale).converter.ConverterNameIsEmpty;
        bReturn = false;
      } else if (newconverterid === converterid) {
        sInfoValidation = "no cambia";
        bReturn = true;
      } else {
        //Test if new name exists
        let i = 0;
        bExiste = false;
        while (i < converters.length && !bExiste) {
          if (converters[i].id === newconverterid) bExiste = true;
          i++;
        }
        if (bExiste) {
          this.ReadConverters();
          if (this.state.ConverterIdInProcessOfRenaming === newconverterid) {
            sInfoValidation = currentLocals(this.props.locale).converter.ConverterNameExist;
          }
          bReturn = false;
        } else {
          updateConverterId({ id: converterid, newid: newconverterid });
          //updateConverterId({ id: this.state.ConverterIdInProcessOfRenaming, newid: newconverterid });
          bReturn = false;
        }
      }
    }
    this.setState({ ConverterIdInProcessOfRenaming: "" });
    if (bReturn === false) event.preventDefault();
    return bReturn;
  };

  ReadConverters(reload) {
    let converters = this.props.converters;

    let converterIn = [];
    let converterOut = [];
    let converterTitleToShow = "";
    let converterTypeInOutLabel = "";
    let convertersToShow = [];

    // Convierte el elemento en el índice 1 de array1 en una cadena de texto en formato JSON
    // Convierte la cadena de texto en un objeto JavaScript
    let copyofconverters = JSON.parse(JSON.stringify(converters));

    for (let i = 0; i < copyofconverters.length; i++) {
      var currentConverter = copyofconverters[i];
      if (
        currentConverter.type === "accumark" ||
        currentConverter.type === "aama_astm" ||
        currentConverter.typeInOut === "In"
      ) {
        //Solo pondremos converters si forman parte de los autorizadso pro la ssubscripción
        if (ConvertTypes.indexOf(currentConverter.type) >= 0) converterIn.push(currentConverter);
      } else if (currentConverter.type === "mdl" || currentConverter.typeInOut === "Out") {
        //Solo pondremos converters si forman parte de los autorizadso pro la ssubscripción
        if (ConvertTypesOut.indexOf(currentConverter.typeDestination) >= 0) converterOut.push(currentConverter);
      }
    }
    converterTitleToShow = currentLocals(this.props.locale).converter.Conversion;
    let converterTypes = this.props.typeInOut === "In" ? ConvertTypes : ConvertTypesOut;

    if (this.props.typeInOut === "In") {
      converterTitleToShow = currentLocals(this.props.locale).converter.ConversionIn;
      convertersToShow = converterIn;
      converterTypeInOutLabel = currentLocals(this.props.locale).converter.InputFormat;
    }
    if (this.props.typeInOut === "Out") {
      converterTitleToShow = currentLocals(this.props.locale).converter.ConversionOut;
      convertersToShow = converterOut;
      converterTypeInOutLabel = currentLocals(this.props.locale).converter.OutputFormat;
    }

    //console.log("Read Converter cambia estado!!");
    this.setState({
      converterTitleToShow: converterTitleToShow,
      converterTypeInOutLabel: converterTypeInOutLabel,
      convertersToShow: convertersToShow,
      converterTypes: converterTypes,
    });
  }

  render() {
    let displayConvertersBodyEmpty;
    if (this.state.convertersToShow.length > 0) displayConvertersBodyEmpty = "none";
    else displayConvertersBodyEmpty = "block";
    displayConvertersBodyEmpty = "block";

    return (
      <div id={`convertermanagerpool${this.props.typeInOut}`} className="convertermanagerpool_00">
        <div>
          <h6>{this.state.converterTitleToShow}</h6>
        </div>

        <div
          className="results-body ConvertersPoolBodyEmpty"
          style={{ display: this.state.convertersToShow.length > 0 ? "none" : "block" }}
        >
          <div className="ConvertersPoolBodyEmpty Description">
            {currentLocals(this.props.locale).converter.NoConverterYet}
          </div>
        </div>
        <div style={{ display: this.state.convertersToShow.length > 0 ? "block" : "none" }}>
          <FormLabel sx={{ marginTop: 2, width: 400 }}>
            {currentLocals(this.props.locale).converter.ConverterName}
          </FormLabel>

          <FormLabel sx={{ marginTop: 2, marginLeft: 1, width: 250 }}>{this.state.converterTypeInOutLabel}</FormLabel>
        </div>
        {this.state.convertersToShow.map((converter, index) => (
          <div id={converter.id} className={`${converter.id === this.state.SelectedConverterId ? "rowselected" : ""}`}>
            <div id={converter.id}>
              <FormControl sx={{ marginTop: 1, width: 400 }}>
                <TextField
                  id={`TextFieldConverter_${converter.id}`}
                  value={converter.id}
                  onChange={(event) => this.handleRename(event.target.value, index, event)}
                  onClick={(event) => this.setState({ SelectedConverterId: converter.id })}
                  onBlur={(event) => this.handleOnBlur(this.state.SelectedConverterId, event.target.value, event)}
                  error={converter.error}
                  helperText={<span>{converter.helperText}</span>}
                  InputProps={
                    converter.error && true
                      ? {
                          classes: {
                            root: "helperText_00",
                          },
                        }
                      : {}
                  }
                ></TextField>
              </FormControl>
              <FormControl sx={{ marginTop: 1, marginLeft: 1, width: 250 }}>
                <Select
                  id={`DropDownTypes${converter.id}`}
                  value={
                    converter.typeInOut === undefined
                      ? converter.type
                      : converter.typeInOut === "In"
                      ? converter.type
                      : converter.typeDestination
                  }
                  onChange={(event) => this.handleChangeType(converter.id, converter.typeInOut, event.target.value)}
                >
                  {this.state.converterTypes.map((type) => (
                    <MenuItem value={type} key={type}>
                      <div style={{ display: "flex" }}>
                        <div className={`square ${type}`}></div>
                        &nbsp;&nbsp;&nbsp;
                        <div>{type}</div>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 2, width: 100 }}>
                <div style={{ display: "flex" }}>
                  <IconButton>
                    <ArrowUpwardIcon
                      color={index === 0 ? "disabled" : "action"}
                      cursor="pointer"
                      onClick={() => {
                        this.handleMoveUp(converter.id, converter.typeInOut);
                      }}
                    />
                  </IconButton>
                  &nbsp;&nbsp;&nbsp;
                  <IconButton>
                    <ArrowDownwardIcon
                      color={index === this.state.convertersToShow.length - 1 ? "disabled" : "action"}
                      cursor="pointer"
                      onClick={() => {
                        this.handlMoveDown(converter.id, converter.typeInOut);
                      }}
                    />
                  </IconButton>
                  &nbsp;&nbsp;&nbsp;
                  <IconButton>
                    <EditIcon
                      color="action"
                      cursor="pointer"
                      onClick={() => {
                        this.handleEdit(converter.id, converter.type, converter.typeInOut);
                      }}
                      style={{ visibility: converter.type === "accumark" ? "visible" : "hidden" }}
                    />
                  </IconButton>
                  &nbsp;&nbsp;&nbsp;
                  <IconButton>
                    <ContentCopyIcon
                      color="action"
                      cursor="pointer"
                      onClick={() => {
                        this.handleCopy(converter.id, converter.typeInOut);
                      }}
                    />
                  </IconButton>
                  &nbsp;&nbsp;&nbsp;
                  <IconButton>
                    <DeleteIcon
                      color="action"
                      cursor="pointer"
                      onClick={() => {
                        this.AskDeleteConverter(converter.id);
                        //this.handleRemove(converter.id);
                      }}
                    />
                  </IconButton>
                  <MuiMessageBox
                    open={this.state.askingDeleteConverter}
                    fullScreen={false}
                    alertType="undefined"
                    content={
                      currentLocals(this.props.locale).converter.sure_to_delete + "\n" + converter.id.toUpperCase()
                    }
                    lang="en-US"
                    onClose={function noRefCheck() {}}
                    primaryButton={{
                      color: "primary",
                      label: "Ok",
                      onClick: () => this.OnOkDelete(converter.id),
                    }}
                    secondaryButtons={[
                      {
                        label: "Cancel",
                        onClick: () => this.OnCancelDelete(),
                      },
                    ]}
                    title={currentLocals(this.props.locale).converter.ConverterManagerDelete}
                  />
                </div>
              </FormControl>
            </div>
          </div>
        ))}

        <MuiLectraButton
          kind="secondary"
          startIcon={<AddIcon></AddIcon>}
          onClick={() => {
            this.handleAdd();
          }}
        >
          {currentLocals(this.props.locale).converter.AddConverter}
        </MuiLectraButton>
      </div>
    );
  }
}
